import { render, staticRenderFns } from "./timerFail.vue?vue&type=template&id=05c0508a&scoped=true&"
import script from "./timerFail.vue?vue&type=script&lang=js&"
export * from "./timerFail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c0508a",
  null
  
)

export default component.exports